import { render, staticRenderFns } from "./toDoList.vue?vue&type=template&id=20f20fce&scoped=true"
import script from "./toDoList.vue?vue&type=script&lang=js"
export * from "./toDoList.vue?vue&type=script&lang=js"
import style0 from "./toDoList.vue?vue&type=style&index=0&id=20f20fce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f20fce",
  null
  
)

export default component.exports